/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SelfServiceDefaultValuesForGcp extends models.SelfServiceDefaultValuesBase {
    getFixupPrototypeFunction() { return SelfServiceDefaultValuesForGcp.fixupPrototype; }

    static newInstance(model: Partial<SelfServiceDefaultValuesForGcp>): SelfServiceDefaultValuesForGcp {
        let obj = Object.assign(new SelfServiceDefaultValuesForGcp(), model);
        SelfServiceDefaultValuesForGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SelfServiceDefaultValuesForGcp>): SelfServiceDefaultValuesForGcp {
        if (!model) return null;
        return SelfServiceDefaultValuesForGcp.newInstance(<SelfServiceDefaultValuesForGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SelfServiceDefaultValuesForGcp) {
        if (!obj) return;

        models.SelfServiceDefaultValuesForGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SelfServiceDefaultValuesForGcp): boolean {
        if (models.SelfServiceDefaultValuesBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SelfServiceDefaultValuesForGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Default Zone
     */
    zone: string;

    /**
     * Default network
     */
    network: string;

    /**
     * Default subnetwork
     */
    subnetwork: string;

}
